export const SETTINGS_SCREEN_APP = "app";
export const SETTINGS_SCREEN_PAYMENT = "payment";
